// @flow

import fetch from 'isomorphic-fetch';
import objectHash from 'object-hash';
import {ApiMethods, ConcurrentStrategies} from './constants';
import {prepareRequestData} from './prepare-request-data';
import {responseToPromise} from './utils/response-to-promise';

import type {CallInfo} from './typedef';

const pendingRequests = {
    [ApiMethods.GET]: {},
    [ApiMethods.POST]: {},
    [ApiMethods.PUT]: {},
    [ApiMethods.PATCH]: {},
    [ApiMethods.DELETE]: {},
    [ApiMethods.CONNECT]: {},
    [ApiMethods.OPTIONS]: {},
    [ApiMethods.HEAD]: {}
};

const resolve = response => responseToPromise(response)
    .then(responseData => ({responseData, response}));

const resolveFromQueue = (response, meta) => {
    delete pendingRequests[meta.method][meta.endpoint];

    return resolve(response);
};

export const request = (callInfo: CallInfo<*>, apiRoot: string): Promise<{
    responseData: *,
    response: Response,
}> => {
    const {method = ApiMethods.GET, concurrentStrategy = ConcurrentStrategies.DEFAULT, endpoint, signal} = callInfo;
    const pack = prepareRequestData(callInfo, apiRoot);
    const isConcurrent = concurrentStrategy !== ConcurrentStrategies.DEFAULT;
    const abortController = isConcurrent || signal ? new AbortController() : null;

    if (signal && abortController) {
        // subscribe to external abort signal, if it's provided
        signal.addEventListener('abort', () => {
            abortController.abort();
        });
    }

    const req = fetch(pack.url,
        {
            credentials: 'include',
            method,
            headers: pack.headers,
            body: pack.body,
            ...(abortController ? {signal: abortController.signal} : null)
        });

    if (isConcurrent) {
        pendingRequests[method][callInfo.endpoint] = pendingRequests[method][endpoint] || [];

        const currentQueue = pendingRequests[method][callInfo.endpoint];
        const hash = objectHash(callInfo);
        const meta = {method, endpoint};

        if (concurrentStrategy === ConcurrentStrategies.FIRST) {

            if (currentQueue.length && abortController) {
                abortController.abort();
            }

            currentQueue.unshift(hash);

        } else if (concurrentStrategy === ConcurrentStrategies.LAST) {
            if (currentQueue.length) {
                currentQueue.forEach(i => {
                    i.abortController.abort();
                });
            }

            currentQueue.push({hash, abortController});
        }

        return req.then(response => {
            return resolveFromQueue(response, meta);
        });
    }

    return req.then(resolve);
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
